"use client";
import { Image } from "antd";
import React from "react";

 const AntImage = ({ src, alt, className }) => {
  return (
    <div className={className}>
      <Image src={src} alt={alt} preview={false} className="!w-full !h-auto" priority="true"   />
    </div>
  );
};

export default AntImage;